import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import NavBar from "../../../../Navbar/Navbar";
import { getDocByIdADM } from "../../../../../AdminAPI/DocByIdADM";
import fetchClient from "../../../../../AdminAPI/ClientList";
import DocsTableComponent from "../../../../Dashboard/Default/TabDocs/DocsTableComponent";
import AdminFullDocTableConfig from "../../AdminFullTableDocConfig.json";
import "./AdmDocId.css";
import { useTranslation } from "react-i18next";

const AdmDocId = () => {
  const idToken = Cookies.get("Token");
  const [docId, setDocId] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [documents, setDocuments] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [filter, setFilter] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const { t } = useTranslation();

  //Get all clients
  useEffect(() => {
    const fetchClientsForModel = async () => {
      setIsLoading(true);
      try {
        const ClientData = await fetchClient(idToken);
        setClients(ClientData);
        setIsLoading(false);
      } catch (error) {
        console.error("Erreur lors du chargement des clients :", error);
      }
    };

    fetchClientsForModel();
  }, []);

  //Set selected client in select
  const handleClientChange = (e) => {
    setSelectedClient(e.target.value);
    localStorage.setItem("selectedClient", e.target.value);
  };

  //Get document where id equal id defined
  const getDocByIdFunction = async () => {
    try {
      const idsArray = docId.split(",").map((id) => id.trim());
      const responsdata = await getDocByIdADM(
        idsArray,
        selectedClient,
        idToken
      );
      if (responsdata === undefined || responsdata.length === 0) {
        setErrorMessage(
          t("No document found check the information you entered.")
        );
        setDocuments([]);
      } else {
        setDocuments(responsdata);
        setErrorMessage("");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des documents :", error);
    }
  };

  // launch GetDocById function
  const getDoc = (e) => {
    e.preventDefault();
    getDocByIdFunction();
  };

  return (
    <div id="adm-doc-search-page">
      <NavBar />


      <div id="adm-doc-search-header">
     
        <div id="adm-doc-search-title-block">
          <h1 id="adm-doc-search-title">
            <i className="fas fa-tasks"></i>
            {t("search by docid")}
          </h1>
          <div id="adm-doc-search-title-line" />
        </div>

    
        {isLoading ? (
          <p id="adm-doc-search-loading">{t("Loading models...")}</p>
        ) : (
          <form id="adm-doc-search-form" onSubmit={getDoc}>
            <select
              value={selectedClient}
              onChange={handleClientChange}
              className="adm-doc-search-select"
              id="adm-doc-search-client-select"
            >
              <option value="">{t("Choose a client")}</option>
              {clients.map((client) => (
                <option value={client.ClientId} key={client.ClientId}>
                  {client.ClientId}
                </option>
              ))}
            </select>

            <input
              type="text"
              value={docId}
              onChange={(e) => setDocId(e.target.value)}
              placeholder={t("Enter your document id")}
              className="adm-doc-search-input"
              id="adm-doc-search-input"
            />

            <button
              id="adm-doc-search-submit-btn"
              className="btn btn-primary"
              type="submit"
            >
              {t("Confirm")}
            </button>
          </form>
        )}
      </div>

      {documents.length > 0 ? (
        <div id="adm-doc-search-table-container">
          <DocsTableComponent
            data={documents}
            clientId={selectedClient}
            page={"DocStatus"}
            tableConfig={AdminFullDocTableConfig}
            selectedDocuments={selectedDocuments}
            setSelectedDocuments={setSelectedDocuments}
            filter={filter}
            setFilter={setFilter}
            setReturn={false}
          />
        </div>
      ) : (
        errorMessage && (
          <div id="adm-doc-error-container">
            <i className="fas fa-folder-open"></i>
            <p id="adm-doc-error-text">{errorMessage}</p>
          </div>
        )
      )}
    </div>
  );
};

export default AdmDocId;
